import { Component, OnInit } from '@angular/core';
import { CommitteeSearchDto } from '../shared/dto/committee-search.dto';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-committee-search',
  templateUrl: './committee-search.component.html',
  styleUrls: ['./committee-search.component.less'],
  standalone: false,
})
export class CommitteeSearchComponent implements OnInit {
  searchParams = new CommitteeSearchDto();

  constructor(public securityElementNames: SecurityElementNames) {}

  ngOnInit(): void {}
}
